import * as Link from './Link.css';

export default {
	Link
};
